function initScrReveal() {
  var els = document.querySelectorAll('.scr-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('scr-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-scr-delay') || 0;
        setTimeout(function () { entry.target.classList.add('scr-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initScrCountUp() {
  var els = document.querySelectorAll('.scr-count');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = Number(el.getAttribute('data-target') || '0');
      var duration = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        el.textContent = Math.floor(progress * target).toLocaleString('es-ES');
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('es-ES');
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initScrProductoGaleria() {
  var wrap = document.querySelector('[data-scr-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-scr-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-scr-galeria-mini]');
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (principal && src) {
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('scr-mini--activa'); });
        mini.classList.add('scr-mini--activa');
      }
    });
  });
}

function initScrVariantes() {
  var form = document.querySelector('[data-scr-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-scr-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-scr-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-scr-precio]');
  var precioCompareEl = document.querySelector('[data-scr-precio-compare]');
  var botonEl = form.querySelector('[data-scr-boton-comprar]');

  function valoresSeleccionados() {
    var vals = [];
    selects.forEach(function (s) { vals.push(s.value); });
    return vals;
  }

  function actualizar() {
    var vals = valoresSeleccionados();
    var encontrada = variantes.find(function (v) {
      return v.options.length === vals.length && v.options.every(function (o, i) { return o === vals[i]; });
    });
    if (!encontrada) return;
    idInput.value = encontrada.id;
    if (precioEl) precioEl.textContent = encontrada.price_formateado;
    if (precioCompareEl) {
      if (encontrada.compare_at_price_formateado) {
        precioCompareEl.textContent = encontrada.compare_at_price_formateado;
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (encontrada.available) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.getAttribute('data-texto-disponible');
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.getAttribute('data-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initScrLightbox() {
  var triggers = document.querySelectorAll('[data-scr-lightbox]');
  if (!triggers.length) return;

  var overlay = document.createElement('div');
  overlay.className = 'scr-lightbox';
  overlay.innerHTML = '<button type="button" class="scr-lightbox__close" aria-label="Close">✕</button><img class="scr-lightbox__img" alt="">';
  document.body.appendChild(overlay);
  var img = overlay.querySelector('.scr-lightbox__img');
  var closeBtn = overlay.querySelector('.scr-lightbox__close');

  function open(src, alt) {
    img.src = src;
    img.alt = alt || '';
    overlay.classList.add('scr-lightbox--open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('scr-lightbox--open');
    document.body.style.overflow = '';
  }

  triggers.forEach(function (el) {
    el.addEventListener('click', function () {
      var full = el.getAttribute('data-scr-lightbox') || el.currentSrc || el.src;
      open(full, el.alt);
    });
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initScrReveal();
  initScrCountUp();
  initScrProductoGaleria();
  initScrVariantes();
  initScrLightbox();
});
